import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/in-store-barcode"
    exact
    path="/business/products/in-store-barcode"
    component={AsyncPage}
  />,
];
